import React, { useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { ULField } from '../JobDetailPage/Additional/ULForms';
import {
  buildULForms,
  defaultValue,
  inputType,
  isControlField,
  matchULLayout,
} from '../JobDetailPage/Additional/ulFormUtils';
import InfoBubbleModal from '../common/InfoBubbleModal';

export default function AdminFormPreview({ parent, fields, onHide }) {
  const [values, setValues] = useState({});
  const [info, setInfo] = useState(null);
  const layout = matchULLayout(fields);
  const ulForm = layout
    ? buildULForms(fields).find((form) => form.id === layout.id)
    : null;
  const sections = ulForm?.sections || [
    {
      title: 'Fields',
      layout: 'checklist',
      fields: fields
        .filter((field) => !isControlField(field))
        .map((field) => ({
          ...field,
          label: field.FieldName,
          type: inputType(field.FieldType),
        })),
    },
  ];
  return (
    <>
      <Modal
        show
        onHide={onHide}
        size="xl"
        scrollable
        aria-labelledby="admin-form-preview-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="admin-form-preview-title">Form preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="info">
            Preview only. Try the inputs below; changes are not saved.
            Activation and locking fields are hidden.
          </Alert>
          <div className="ul-forms__sheet">
            <header className="ul-forms__sheet-heading">
              <h3>{parent.FormName}</h3>
              <p>Form ID: {parent.Id ?? 'Not assigned'}</p>
            </header>
            {sections.map((section) => (
              <section
                key={section.title}
                className={`ul-forms__section ul-forms__section--${section.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
              >
                <h5>{section.title}</h5>
                {section.fields.some((field) => field.type === 'yesna') && (
                  <p className="ul-forms__instruction">
                    All items listed are either checked Yes or N/A.
                  </p>
                )}
                <div
                  className={
                    section.layout === 'grid'
                      ? 'ul-forms__grid'
                      : 'ul-forms__rows'
                  }
                >
                  {section.fields.map((field) => (
                    <ULField
                      key={field.Id}
                      field={field}
                      value={values[field.Id] ?? defaultValue(field)}
                      disabled={false}
                      prefix="admin-preview"
                      onChange={(value) =>
                        setValues((previous) => ({
                          ...previous,
                          [field.Id]: value,
                        }))
                      }
                      onInfo={setInfo}
                    />
                  ))}
                </div>
              </section>
            ))}
            {!sections.some((section) => section.fields.length) && (
              <p>No visible fields yet. Add fields to preview this form.</p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setValues({})}>
            Reset preview
          </Button>
          <Button onClick={onHide}>Close preview</Button>
        </Modal.Footer>
      </Modal>
      <InfoBubbleModal
        show={Boolean(info)}
        onHide={() => setInfo(null)}
        sectionName={parent.FormName}
        value={info?.FieldName || ''}
        title={info?.label || 'Field information'}
        description={info?.FieldDescription ?? ''}
      />
    </>
  );
}
